import _objectWithoutProperties from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-3/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Component } from "react";
import { Field } from "redux-form";
// import { Field } from 'react-final-form';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
class InputToggle extends Component {
  constructor(props) {
    super(props);
    this.renderCheckbox = _ref => {
      let input = _ref.input,
        label = _ref.label,
        helperText = _ref.helperText,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error,
        custom = _objectWithoutProperties(_ref, ["input", "label", "helperText", "meta"]);
      return /*#__PURE__*/React.createElement(FormControl, {
        component: "fieldset"
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
        control: /*#__PURE__*/React.createElement(Checkbox, {
          size: "medium",
          color: "primary",
          label: label,
          checked: input.value,
          onChange: input.onChange
        }),
        label: label
      })), /*#__PURE__*/React.createElement(FormHelperText, null, helperText));
    };
    this.state = {
      value: props.value
    };
  }
  render() {
    const _this$props = this.props,
      name = _this$props.name,
      fieldName = _this$props.fieldName,
      disabled = _this$props.disabled,
      className = _this$props.className,
      label = _this$props.label,
      helperText = _this$props.helperText;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      component: this.renderCheckbox,
      label: label,
      helperText: helperText,
      name: fieldName,
      disabled: disabled,
      className: className,
      style: disabled ? {
        display: "none"
      } : {
        padding: 0
      },
      context: this.props.context
    }));
  }
}
InputToggle.defaultProps = {
  disabled: true,
  name: null,
  value: null,
  className: null
};
export default InputToggle;